import TotalParikami from "./Default/TotalParikami's/TotalParikami.jsx";
import { Breadcrumbs } from "../../AbstractElements";
import { Col, Container, Row } from "reactstrap";
import ActiveParikami from "./Default/ActiveParikami/ActiveParikami.jsx";
import NumberOfBlogs from "./Default/NumberOfBlogs/NumberOfVolunteers.jsx";
import RecentJoins from "./Default/RecentJoins/RecentJoins.jsx";
import ActiveParikamiTable from "./Default/ActiveParikamiTable/ActiveParikamiTable.jsx";

const Default = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Dashboard" parent="Dashboard" title="Dashboard" />
      <div>
        <Container fluid={true} className="dashboard-default">
          <Row>
            <Col xl={9} md={12} className="box-col-70 xl-70">
              <Row>
                <TotalParikami />
                <ActiveParikami />
                <NumberOfBlogs />
              </Row>
              <Row>
                <RecentJoins />
              </Row>
            </Col>
            <Col xl={3} md={6} lg={5} className="box-col-30 xl-30">
              <ActiveParikamiTable />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Default;
